import {
	InboundArs,
	InboundCrypto,
	OutboundArs,
	OutboundCrypto,
	Price,
} from "../../tables/transactions-table/data/types"
import { TableMovement } from "../../tables/transactions-table/data/types"
import SlidingCard from "../../ui/sliding-card"
import OutboundTransactionModalBody from "../payment-modal/body/OutboundTransactionModalBody"
import InboundTransactionModalBody from "./body/InboundTransactionBody"
import TransactionStatusRow from "./header/TransactionStatusRow"

export interface Paymentcommission {
	commission?: Price
	commissionInRequestedCurrency?: Price
	percent?: number
}

interface TransactionModalProps {
	open: boolean
	onClose: () => void
	transaction: TableMovement
}
const MovementModal = ({
	open,
	onClose,
	transaction,
}: TransactionModalProps) => {
	return (
		<SlidingCard
			open={open}
			onOpenChange={(open) => {
				if (!open) onClose()
			}}
			side={"right"}
		>
			<div>
				<TransactionStatusRow
					status={transaction.status}
					type={transaction.type}
				/>
				{renderModalBody(transaction)}
			</div>
		</SlidingCard>
	)
}
function renderModalBody(transaction: TableMovement) {
	if(transaction.type === "INBOUND") {
		return (
			<InboundTransactionModalBody
				transaction={transaction as InboundArs | InboundCrypto}
			/>
		)
	} else {
		return (
			<OutboundTransactionModalBody
				transaction={transaction as OutboundArs | OutboundCrypto}
			/>
		)
	}
}

export default MovementModal
